import { FC } from 'react';

const SearchIcon: FC = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.25 14C13.058 14 12.866 13.927 12.72 13.78L8.755 9.815C8.462 9.522 8.462 9.047 8.755 8.754C9.048 8.461 9.523 8.461 9.816 8.754L13.781 12.719C14.074 13.012 14.074 13.487 13.781 13.78C13.635 13.926 13.443 14 13.251 14H13.25Z"
        fill="#6C6B73"
      />
      <path
        d="M5.75 11.5C2.58 11.5 0 8.92 0 5.75C0 2.58 2.58 0 5.75 0C8.92 0 11.5 2.58 11.5 5.75C11.5 8.92 8.92 11.5 5.75 11.5ZM5.75 1.5C3.407 1.5 1.5 3.407 1.5 5.75C1.5 8.093 3.407 10 5.75 10C8.093 10 10 8.093 10 5.75C10 3.407 8.093 1.5 5.75 1.5Z"
        fill="#6C6B73"
      />
    </svg>
  );
};

export default SearchIcon;
